import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';

const UploadProgress = ({ progress, status, errorMessage }) => {
  if (status === 'idle') return null;

  return (
    <div className="mt-6 p-5 border border-gray-100 rounded-xl bg-white shadow-sm transition-all duration-300">
      {status === 'uploading' && (
        <div className="space-y-3">
          <div className="flex justify-between items-center text-sm">
            <span className="font-medium text-gray-700 animate-pulse">Uploading Document...</span>
            <span className="font-bold text-blue-600">{progress}%</span>
          </div>
          <div className="w-full bg-gray-100 rounded-full h-2.5 overflow-hidden">
            <div 
              className="bg-blue-600 h-2.5 rounded-full transition-all duration-300 ease-out"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>
      )}

      {status === 'success' && (
        <div className="flex items-center space-x-3 text-green-600">
          <CheckCircle className="w-6 h-6" />
          <span className="font-medium">Upload Successful! Processing will begin shortly.</span>
        </div>
      )}

      {status === 'error' && (
        <div className="flex items-center space-x-3 text-red-500 bg-red-50 p-3 rounded-lg border border-red-100">
          <AlertCircle className="w-6 h-6 flex-shrink-0" />
          <span className="font-medium">{errorMessage || 'Upload failed. Please try again.'}</span>
        </div>
      )}
    </div>
  );
};

export default UploadProgress;
